const sensors = {
    battery_voltage: String("Tensión de batería"),
    soil_1_meter: String("Sonda suelo 15cm"),
    soil_2_meter: String("Sonda suelo 30cm"),
    soil_3_meter: String("Sonda suelo 45cm"),
    leaf_meter: String("Humedad en Hoja"),
    hum_meter: String("Humedad Relativa"),
    temp_meter: String("Temperatura"),
    rain_meter: String("Pluviometria"),
    gauge_meter: String("Caudalimetro"),
};

export default sensors;